import React,{useEffect,useRef} from 'react'
import { FaPaintBrush } from "react-icons/fa";
import { FaRobot } from "react-icons/fa";
import { BsCodeSquare } from "react-icons/bs";
import gsap from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import "./Services.css"

const Services = () => {
  gsap.registerPlugin(ScrollTrigger);
  const container = useRef(null);
  //Register plugin
    useEffect(() => {
        const el = container.current;
        gsap.fromTo('.service__head', 
          { 
            opacity:0,
          }, 
          {
            opacity:1,
            scrollTrigger: {
                trigger: el,
            }
          })


        gsap.fromTo('.service', 
          { 
            y: -50,
            opacity:0,
          }, 
          {
            y: 0, 
            opacity:1,
            duration: 1, 
            scrollTrigger: {
                trigger: el,
                start:"-100% bottom",
                end:"bottom 20%",
                scrub:true,
            }
          })
    }, [])




  return (
    <section ref={container} id='services'>
        <div className="section__wrapper services__container">
          <div className="section__header center">
             <h2 className='primary__title'>Services</h2>
             <h3 className="text__muted description">
               I transform your ideas, and consequently your desires, into a distinctive web project that both inspires you and captivates your customers.
             </h3>
          </div>
          <div className="services__group">
            <article className="service">
                <div className="service__top">
                    <div className="icon__container">
                       <FaPaintBrush className='icon'/>
                    </div>
                    <h3 className='title'>UI/UX <br/> Designer</h3>
                </div>
                <div className="service__middle">
                  <p className="text__muted description">
                   With a keen eye for detail and a deep understanding of user behavior, I transform complex ideas into elegant, user-friendly interfaces. My expertise spans across user research, wireframing, prototyping, and visual design, ensuring each project I work on is both functional and visually captivating.
                  </p>
                </div>
            </article>
            {/* END UI/UX */}
    
    
            <article className="service" style={{"--color-primary":'var(--color-success)'}}>
                 <div className="service__top">
                    <div className="icon__container">
                       <BsCodeSquare className='icon'/>
                    </div>
                    <h3 className='title'>Web Development</h3>
                </div>
    
                <div className="service__middle">
                  <p className="text__muted description">
                  I'm a dedicated web developer with a passion for crafting dynamic and responsive websites. With a strong foundation in both front-end and back-end technologies, I transform ideas into seamless digital experiences. My expertise includes coding, debugging, and optimizing web applications to ensure they are both user-friendly and performant.
                  </p>
                </div>
            </article>
            {/* END WEB DEVELOPMENT */}
    
    
            <article className="service" style={{"--color-primary":'blueviolet'}}>
               <div className="service__top">
                    <div className="icon__container">
                       <FaRobot className='icon'/>
                    </div>
                    <h3 className='title'>Bot <br/>Development</h3>
                </div>
    
                <div className="service__middle">
                  <p className="text__muted description">
                  I'm a skilled bot developer focused on creating intelligent and efficient automated solutions.I design and implement bots that enhance user interactions and streamline processes. My goal is to build smart, reliable, and scalable bots that deliver real value.
                  </p>
                </div>
            </article>
            {/* END CONTENT CREATION */}
    
    
          </div>
      </div>
    </section>
  )    
}    

export default Services
